import React from "react";
import ProdLayout from "../../prodlayout";
import pi1 from "./p1.jpg";
import pi2 from "./p2.jpg";
import pi3 from "./p3.jpg";
import pi4 from "./p4.jpg";
const data = {
  images: [pi1, pi2, pi3, pi4],
  badge: "Solid",
  sku: "TPK194",
  availability: "In stock",
  title: "OCSO Solid Men's T-shirt TPK194",
  mrpPrice: "1540",
  sellPrice: "890",
  disc:
    "Men's T-shirt from OCSO INTERNATIONAL engineered with breathable, rapid-dry fabric.Soft, comfortable, vibrant and multi- functional sports t-shirts. Gear suitable for all Weathers. Made from a sweat-absorbent Dry-fit polyester material, Material: 100% Micro-polyester, smoother than fabric.",
};
export default () => {
  return <ProdLayout data={data} />;
};
